import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import { RemuneracaoMedica } from '@/types/core'
import { signalRRemuneracaoBackofficeService } from '@/services/signalR-remuneracao-backoffice.service'
import { Recebimento } from '@/types/_'

@Module({ namespaced: true, name: 'FinanceiroBackofficeChatStore' })
export default class FinanceiroBackofficeChatStore extends VuexModule {
  remuneracaoMedica: RemuneracaoMedica.IPrestadorRecebimento = new RemuneracaoMedica.PrestadorRecebimento()

  public pagina: number = 1
  public qtdPorPagina: number = 25
  public totalBackofficeChats: number = 0
  public itemsBakofficeChat: any[] = []
  public recebimento: any = {}
  public sortBy: string = ''

  public headerBackofficeChat: any = [
    { text: 'Requisitante', value: 'requisitante', align: 'center', sortable: false },
    { text: 'Fonte pagadora', value: 'fontePagadora', align: 'center', sortable: false },
    { text: 'Nome grupo repasse', value: 'nomeGrupoRepasse', align: 'center', sortable: false },
    { text: 'Responsável', value: 'reponsavel', align: 'center', sortable: false },
    { text: 'Empresa médica', value: 'empresaMedica', align: 'center', sortable: false },
    { text: 'Última interação', value: 'ultimaInteracao', align: 'center', sortable: false },
    { text: 'Valor nota', value: 'valorNota', align: 'center', sortable: false },
    { text: 'Mês referência', value: 'mesreferencia', align: 'center', sortable: false },
    { text: 'Área responsável', value: 'areaResponsavel', align: 'center', sortable: false },
    { text: 'Status', value: 'status', align: 'center', sortable: false },
    { text: 'Chat', value: 'chat', align: 'center', sortable: false },
  ]

  @Mutation
  setPagina(value: number) {
    this.pagina = value
  }

  @Mutation
  setBackofficeChatItems(value: any[]) {
    this.itemsBakofficeChat = value
  }

  @Mutation
  setRecebimento(value: any) {
    this.recebimento = value
  }

  @Mutation
  setSortBy(value: string) {
    this.sortBy = value
  }

  @Action
  async getBackofficeChatItems() {
    try {
      const params: any = {
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
      }
      const response = await this.remuneracaoMedica.getBackofficeChatItems(params)

      if (response.success) {
        this.context.commit('setBackofficeChatItems', response.data.itens)
      }

      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async geRecebimentoById(id: string) {
    try {
      const response = await this.remuneracaoMedica.geRecebimentoById(id)

      if (response.success) {
        this.context.commit('setRecebimento', response.data)
      }

      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async openConnection(id: any) {
    await signalRRemuneracaoBackofficeService.openConnection(id)
  }
}
